import * as URLConfig from "@frameworks/salesjourney/config/domain";
import { microService } from "../microServiceBase";
var salesLeadUrlConfig = {
    SelfAssign: URLConfig.config.apiBase + microService.leadService + "Leads/SelfAssign",
    leadsummaryDB: URLConfig.config.apiBase + microService.dashboardService + "Leads/Summary",
    leadPurchaseHistory: URLConfig.config.apiBase +
        microService.leadService +
        "Client/PurchaseHistory",
    viewLeadDetails: URLConfig.config.apiBase + microService.leadService + "Leads/View",
    viewEditLeadDetails: URLConfig.config.apiBase + microService.leadService + "Leads/Viewedit",
    reassignTask: URLConfig.config.apiBase + microService.leadService + "Leads/ReassignTask",
    editLeadAccess: URLConfig.config.apiBase + microService.leadService + "Leads/EditLead",
    resassignLeadCheck: URLConfig.config.apiBase + microService.leadService + "Leads/RAReAssign",
    childLeadData: URLConfig.config.apiBase + microService.leadService + "Leads/ChildLead",
    leadDetails: URLConfig.config.apiBase + microService.leadService + "Leads/Details",
    getEmployees: URLConfig.config.apiBase + microService.masterSevice + "Search/Empolyee",
    leadPastIntraction: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/PastInteractions",
    internalComments: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/internalcomments",
    viewEditMultipleLeadsDetails: URLConfig.config.apiBase + microService.leadService + "Leads/Vieweditleads",
    checkMomStatus: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/checkMOMStatus",
    sendViewMomTemplate: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/SendviewMomtemplate",
    editMomTemplate: URLConfig.config.apiBase +
        microService.leadService +
        "Leads/editmomtemplate",
    getMomAttachFiles: URLConfig.config.apiBase + microService.leadService + "MOM/getmomFiles",
    momDownloadFile: URLConfig.config.apiBase + microService.leadService + "MOM/downloadFile",
    viewMomDetails: URLConfig.config.apiBase +
        microService.leadService +
        "MOMDocuments/MOMmailDetails",
    viewMomAttachmentDownload: URLConfig.config.apiBase +
        microService.leadService +
        "MOMDocuments/MOMmailAttachment",
};
export default salesLeadUrlConfig;
